'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _publicToolbar = require('../../public-toolbar');

var _publicToolbar2 = _interopRequireDefault(_publicToolbar);

var _contact = require('../../contact');

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganizersController = function () {
  function OrganizersController($document, config, fContactService) {
    _classCallCheck(this, OrganizersController);

    this.config = config;
    this._svc = {
      $document: $document, fContactService: fContactService
    };

    $document.scrollTop(0, 1000);
  }

  _createClass(OrganizersController, [{
    key: 'sendMessage',
    value: function sendMessage(msg) {
      var _this = this;

      this.error = "";
      this.sending = true;
      this.success = "";
      this._svc.fContactService.email(msg).then(function () {
        _this.sending = false;
        _this.success = 'Success! Email sent successfully!';
        _this.msg = {};
      }, function (err) {
        _this.sending = false;
        _this.error = 'Error! ' + err.data.errors[0].title;
      });
    }
  }]);

  return OrganizersController;
}();

exports.default = angular.module('ifeis.routes.organizers', ['ui.router', 'ifeis.public-toolbar', 'ifeis.contact', 'duScroll']).config(function ($stateProvider) {
  $stateProvider.state('organizers', {
    url: '/organizers',
    controller: 'OrganizersController',
    controllerAs: 'ctrl',
    template: require('./tpl.html')
  });
}).controller('OrganizersController', OrganizersController);


//////////////////
// WEBPACK FOOTER
// ./routes/organizers/index.js
// module id = 601
// module chunks = 0